/*
 * @Author: 317473294@qq.com
 * @Date: 2022-02-25 17:14:38
 * @LastEditTime: 2026-09-01 13:48:32
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /fj_jx_admin/src/axios/index.js
 */
import axios from "axios";
import store from "@/store/index.js"
import { Message } from "element-ui";
var Axios = axios.create({
  //withCredentials: true, // 跨域请求时发送Cookie,这里先注释掉，不然导致跨域问题
  timeout: 60000, //请求超时
  //本地
  // baseURL:'http://127.0.0.1:7001'
  //福建
  // baseURL:'https://fjzsbapi.learnpathway.com'
  //江西门户
  baseURL:'https://jszsbapi.learnpathway.com'
  //江西后台
  // baseURL:'https://eduadmin.learnpathway.com'
  //医学平台
  // baseURL:"https://medicineapi.learnpathway.com"
}
);
//请求加拦截
Axios.interceptors.request.use(
  (config) => {
    // token认证写在这里
    console.log("请求拦截器=》",store.state.userinfo)
    if(store.state.token){
      config.headers.common['authorization']="Bearer "+store.state.token 
    }
    if(store.state.refreshToken){
      config.headers.common['refreshToken']="Bearer "+store.state.refreshToken
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 响应拦截
Axios.interceptors.response.use((respones) => {
    //对相应数据做些什么
    let {status,msg,refreshToken}=respones.data
    console.log("响应拦截",respones.data)
    if(status==401)
    { 
      //console.log("请重新登录")
    //提示重新登录
     Message({message:msg,type:'warning'})
     setTimeout(() => {
      //跳转到登录页
      window.location.href = '/login';
     }, 1500);
    }else if(refreshToken){
       //存储refreshToken
       localStorage.setItem('refreshToken',refreshToken)
    }
    return respones;
  },
  (error) => {
    
     return Promise.reject(error);
  }
);

export default Axios



// WEBPACK FOOTER //
// ./src/axios/index.js